import { withStyles } from '@material-ui/core';
import { Marker } from '../../../../../lib/Map';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import GeoFenceEntryExitIcon from '../StopDetails/GeoFenceEntryExitIcon';
import { getTimeString } from '../Utils';
import LeaveTerminalIcon from '../../../Dispatch/RouteExecution/utils/DriverStatus/Icons/LogoutIcon';
import EnterTerminalIcon from '../../../Dispatch/RouteExecution/utils/DriverStatus/Icons/EnterTerminalIcon';

const styles = (theme) => ({
  time: {
    paddingLeft: 6
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginTop: -30
  },
  tooltipLabel: {
    backgroundColor: theme.tooltipBGColor,
    color: theme.iconColor,
    padding: '4px 8px',
    borderRadius: 4,
    letterSpacing: 0.5,
    display: 'flex',
    alignItems: 'center'
  },
  arrow: {
    fontSize: 49,
    margin: '-21 0 -18',
    color: theme.tooltipBGColor
  },
  labelContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    zIndex: 2
  }
});

const GeofenceMarker = ({ classes, theme, markerKey, geofenceData, IconComponent }) => {
  if (geofenceData?.lat && geofenceData?.lng && geofenceData?.time) {
    return (
      <Marker position={{ lat: geofenceData.lat, lng: geofenceData.lng }} key={markerKey} zIndex={1} onClick={null}>
        <div className={classes.container}>
          {geofenceData.time ? (
            <div className={classes.labelContainer}>
              <span className={classes.tooltipLabel}>
                <IconComponent color={theme.iconColor} />
                <span className={classes.time}>{getTimeString(geofenceData.time)}</span>
              </span>
              <ArrowDropDownIcon className={classes.arrow} />
            </div>
          ) : null}
          <GeoFenceEntryExitIcon />
        </div>
      </Marker>
    );
  }
  return null;
};

const StopGeofenceEntryExitMarker = ({ classes, theme, key, entry, exit }) => {
  return (
    <>
      <GeofenceMarker 
        classes={classes}
        theme={theme}
        markerKey={`${key}_entry`}
        geofenceData={entry}
        IconComponent={EnterTerminalIcon}
      />
      
      <GeofenceMarker 
        classes={classes}
        theme={theme}
        markerKey={`${key}_exit`}
        geofenceData={exit}
        IconComponent={LeaveTerminalIcon}
      />
    </>
  );
};

export default withStyles(styles)(StopGeofenceEntryExitMarker);
